import { NgModule } from '@angular/core';
import { AngularMenuModule, 
         AngularBreadcrumbModule, 
         AngularAlertModule, 
         AngularConfirmModule } from 'angular-library';

import { PageMasterComponent } from './pagemaster.component';
import { TopbarModule } from './topbar.module';
import { SharedModule } from '../../shared/shared.module';
import { PageMasterRouting } from './pagemaster.routing';

@NgModule({
    imports: [ 
        SharedModule,
        AngularMenuModule,
        AngularBreadcrumbModule,
        TopbarModule,
        PageMasterRouting,
        AngularAlertModule,
        AngularConfirmModule,
        ],
    declarations: [ PageMasterComponent ],
    exports : [ ],
    providers: []
})
export class PageMasterModule { }


// WEBPACK FOOTER //
// ./src/app/core/masterComponent/pagemaster.module.ts